// Per-section ambient color themes — drives the drifting aurora background.
// Grouped by canonical book sections so the mood shifts as you move through scripture.

const THEMES = {
  law:       { a: "#C48B5D", b: "#7A8450", c: "#3E5641" }, // earth / wilderness
  history:   { a: "#B5784C", b: "#8C6239", c: "#5E4A2E" }, // bronze / kingdom
  wisdom:    { a: "#D4AF37", b: "#9C7BB0", c: "#4A5C8C" }, // gold / royal
  prophets:  { a: "#C0563B", b: "#8A3F33", c: "#46303B" }, // fire / judgment
  gospels:   { a: "#E0B85C", b: "#5C8A6E", c: "#2E5A66" }, // dawn / living water
  acts:      { a: "#D98C5F", b: "#B6504B", c: "#5A3B66" }, // pentecost flame
  epistles:  { a: "#6E8FB0", b: "#5C7A8A", c: "#384C66" }, // sea / letters
  apocalypse:{ a: "#D4AF37", b: "#B53A3A", c: "#2C2A55" }, // glory / throne
};

const SECTION_OF = {
  // Law
  GEN: "law", EXO: "law", LEV: "law", NUM: "law", DEU: "law",
  // History
  JOS: "history", JDG: "history", RUT: "history", "1SA": "history", "2SA": "history",
  "1KI": "history", "2KI": "history", "1CH": "history", "2CH": "history",
  EZR: "history", NEH: "history", EST: "history",
  // Wisdom
  JOB: "wisdom", PSA: "wisdom", PRO: "wisdom", ECC: "wisdom", SNG: "wisdom",
  // Prophets
  ISA: "prophets", JER: "prophets", LAM: "prophets", EZK: "prophets", DAN: "prophets",
  HOS: "prophets", JOL: "prophets", AMO: "prophets", OBA: "prophets", JON: "prophets",
  MIC: "prophets", NAM: "prophets", HAB: "prophets", ZEP: "prophets", HAG: "prophets",
  ZEC: "prophets", MAL: "prophets",
  // Gospels
  MAT: "gospels", MRK: "gospels", LUK: "gospels", JHN: "gospels",
  // Acts
  ACT: "acts",
  // Epistles
  ROM: "epistles", "1CO": "epistles", "2CO": "epistles", GAL: "epistles", EPH: "epistles",
  PHP: "epistles", COL: "epistles", "1TH": "epistles", "2TH": "epistles", "1TI": "epistles",
  "2TI": "epistles", TIT: "epistles", PHM: "epistles", HEB: "epistles", JAS: "epistles",
  "1PE": "epistles", "2PE": "epistles", "1JN": "epistles", "2JN": "epistles",
  "3JN": "epistles", JUD: "epistles",
  // Apocalypse
  REV: "apocalypse",
};

export const SECTION_LABEL = {
  law: "The Law", history: "History", wisdom: "Wisdom & Poetry",
  prophets: "Prophets", gospels: "The Gospels", acts: "Acts",
  epistles: "Epistles", apocalypse: "Revelation",
};

export function getSection(bookId) {
  return SECTION_OF[bookId] || "gospels";
}

export function getBookTheme(bookId) {
  return THEMES[getSection(bookId)] || THEMES.gospels;
}
